module.exports = __webpack_public_path__ + "media/images/flags/32/Iran-480cf243aa89a60153cfd27062d14844.png";